import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
//import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material-module';
import { CurrencyMaskModule } from 'ng2-currency-mask';

import { EnumToArrayPipe } from './shared/pipes/enum-to-array.pipe';
import { RoundPipe } from './shared/pipes/round-to-floor';
import { CurrencyPipe } from '@angular/common';

@NgModule({
    declarations: [
        EnumToArrayPipe,
        RoundPipe,
    ],
    imports: [
        CommonModule,
        MaterialModule,
        CurrencyMaskModule,
        //BrowserAnimationsModule,
        // NoopAnimationsModule
    ],
    exports: [
        EnumToArrayPipe,
        RoundPipe,
        MaterialModule,
        CurrencyMaskModule
    ],
    providers: [
        EnumToArrayPipe,
        RoundPipe,
        CurrencyPipe
    ]
})
export class SharedModule {}
